import { jsx as _jsx } from "react/jsx-runtime";
import { ErrorDisplay } from '../ErrorDisplay/ErrorDisplay.js';
import { Loader } from '../Loader/Loader.js';
/**
 * Renders a loader component that can display an error message.
 */
export function ErrorableLoader({ className, error, header, actions, }) {
    if (!error) {
        return _jsx(Loader, { className: className });
    }
    return _jsx(ErrorDisplay, { header: header, error: error, actions: actions });
}
